"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Chip = _interopRequireDefault(require("../Chip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Selection = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Selection, _Component);

  var _super = _createSuper(Selection);

  function Selection() {
    var _this;

    (0, _classCallCheck2.default)(this, Selection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDelete", function (event) {
      var _this$props = _this.props,
          onRemove = _this$props.onRemove,
          value = _this$props.value;
      event.preventDefault();
      event.stopPropagation();
      onRemove(value);
    });
    return _this;
  }

  (0, _createClass2.default)(Selection, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          children = _this$props2.children,
          onRemove = _this$props2.onRemove;

      if (onRemove) {
        return /*#__PURE__*/_react.default.createElement(_Chip.default, {
          id: id,
          tabIndex: -1,
          label: children,
          onDelete: this.onDelete
        });
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          id: id,
          className: "Select-value"
        }, children);
      }
    }
  }]);
  return Selection;
}(_react.Component);

exports.default = Selection;
(0, _defineProperty2.default)(Selection, "propTypes", {
  /**
   * The html id.
   */
  id: _propTypes.default.string,

  /**
   * The display contents of the selection element.
   */
  children: _propTypes.default.node,

  /**
   * If set, will display value as a Chip element with a clickable `Delete` icon
   */
  onRemove: _propTypes.default.func,

  /**
   * The value of the selected element.
   */
  value: _propTypes.default.any
});